'use strict';

var _ = require('lodash');
var dataHandler = require('./dataHandler');
var statePropsHandler = require('./statePropsHandler');
var configMenuHandler = require('./configMenuHandler');
var d3ParallelPlot = require('../paralelPlot/d3_PP_Canvas');

var updateHandler = {};
var selfDataObj = {};

updateHandler.externalDataTarget = null;

updateHandler.init = function (data, config, environment, rootElement) {

  // console.log('init update handler :',environment);
  // console.log('init update handler :',config);

  updateHandler.environment = environment;
  updateHandler.stateProps = statePropsHandler.getInitialState();
  updateHandler.stateProps.onFilterUpdate = updateHandler.filterUpdate;
  updateHandler.stateProps.onColumnConfigUpdate = updateHandler.onColumnConfigUpdate;
  updateHandler.stateProps.onCohortUpdate = updateHandler.onCohortUpdate;
  //    updateHandler.stateProps.externalDataTarget=updateHandler.externalDataTarget;

  selfDataObj.elPP = document.getElementById("card-similar-patients");

  // clear all current elements
  while (selfDataObj.elPP.lastElementChild) {
    selfDataObj.elPP.removeChild(selfDataObj.elPP.lastElementChild);
  }

  selfDataObj.d3Graph = d3ParallelPlot();
  selfDataObj.d3Graph.create(selfDataObj.elPP, environment, 'parallelPlot');

  var root = { setState: updateHandler.updateGraph, stateProps: updateHandler.stateProps };

  if (environment === 'logi') {
    dataHandler.initLogiVersion(root, data, config, environment);
  } else if (environment === 'standAlone') {
    dataHandler.initStandAloneVersion(root, data, config, environment);
  } else if (environment === 'ISPM') {
    dataHandler.initISPMVersion(root, data, config, rootElement);
  };
};

updateHandler.updateGraph = function (props) {

  console.log(props);

  if (props.updateType === 'init') {

    var isISPM = updateHandler.environment === 'ISPM';

    var configProps = {
      data: props.data.config,
      onColumnConfigUpdate: updateHandler.onColumnConfigUpdate
    };

    if (!isISPM) {
      configMenuHandler.init(configProps, updateHandler.environment);
    }

    updateHandler.buildExternalCollectibleColumns(props.data.parallelPlot);

    if (isISPM) {
      updateHandler.updateISPM({ filtersActive: false });
    }

    window.addEventListener("resize", updateHandler.onResize);
  }

  updateHandler.checkValidationWarnings(props);

  selfDataObj.d3Graph.update(selfDataObj.elPP, props);
};

updateHandler.checkValidationWarnings = function (props) {

  // check if the number of current patients population is less than the minimal threshold
  var minSampleSize = props.data.config.minSampleSize;

  // check first the total number of patients
  var sampleSize = props.data.totalNRPatients;
  var sampleSizeTooSmall = sampleSize < minSampleSize;

  // check now the number of filtered patients
  if (!sampleSizeTooSmall && props.filtersActive) {
    sampleSize = props.data.filters.patients.length;
    sampleSizeTooSmall = sampleSize < minSampleSize;
  }

  // in case that samples size is too small, set an object that indicates it and with the exact parameters for the message
  var warnObject = false; // this value is used in case that data is valid

  if (sampleSizeTooSmall) {
    warnObject = {
      warning: true,
      params: {
        sampleSize: sampleSize,
        minSampleSize: minSampleSize
      }
    };
  }

  // set the value to properties
  props.data.validationWarnings.sampleSizeTooSmall = warnObject;

  // invoke an event by the specific implementation
  if (dataHandler.internalHandlerImpl.onChangeSampleSizeWarning) {
    dataHandler.internalHandlerImpl.onChangeSampleSizeWarning(sampleSizeTooSmall);
  }
};

updateHandler.filterUpdate = function (filterProps, init) {

  updateHandler.stateProps = statePropsHandler.getFilterUpdateState(updateHandler.stateProps.data, filterProps);

  updateHandler.updateGraph(updateHandler.stateProps);

  if (filterProps.reportUpdate) {

    if (updateHandler.environment === 'ISPM') updateHandler.updateISPM(filterProps);

    if (updateHandler.environment === 'logi' && !init) updateHandler.updateLogi(filterProps);

    var logiDebug = false;
    if (updateHandler.environment === 'standAlone' && logiDebug && !init) {
      updateHandler.updateLogi(filterProps);
    }
  }
};

updateHandler.onColumnConfigUpdate = function (configColumns) {

  var updatedColumnConfig = [];

  _.each(updateHandler.stateProps.data.parallelPlot, function (d, i) {

    var column = _.find(configColumns, function (c) {
      return c.column.id === d.column.id;
    });

    if (d.active !== column.active || d.header !== column.header) {
      d.active = column.active;
      d.header = column.header;
      updatedColumnConfig.push(d);
    };
  });

  updateHandler.stateProps.updatedColumnConfig = updatedColumnConfig;
  updateHandler.stateProps.updateType = 'updateColumnConfigurations';
  updateHandler.stateProps.graphUpdate = true;
  updateHandler.stateProps.tweenTime = 500;

  updateHandler.updateGraph(updateHandler.stateProps);
};

updateHandler.onCohortUpdate = function (props) {
  var stateData = statePropsHandler.getCohortUpdateState(selfDataObj.state.data, props, selfDataObj.props.dataHandler.getCohortIndex);
};

updateHandler.updateISPM = function (filterProps) {
  console.log('Filter update ISPM report :', filterProps);

  if (!updateHandler.externalDataTarget) return;

  var nrPatients = void 0;

  if (filterProps.filtersActive) {

    nrPatients = filterProps.data.patients.length;

    _.each(updateHandler.extrnalCollectColumns, function (c) {
      var column = c.column;

      var columnDataCollector = updateHandler.factorDataCollector(column);

      _.each(filterProps.data.patients, function (p) {

        if (column.categories) {

          _.each(column.categories, function (cat) {

            if (cat.patientsIdMap[p.patientID]) {
              columnDataCollector.addValue(cat.label);
            }
          });
        } else {

          var colPatient = column.patientsIdMap[p.patientID];
          if (colPatient) {
            columnDataCollector.addValue(colPatient.value);
          }
        }
      });

      updateHandler.publishExternalData(column.id, columnDataCollector);
    });
  } else {

    nrPatients = selfDataObj.d3Graph.totalNRPatients;

    _.each(updateHandler.extrnalCollectColumns, function (c) {
      var column = c.column;

      var columnDataCollector = updateHandler.factorDataCollector(column);

      if (column.categories) {

        _.each(column.categories, function (cat) {
          columnDataCollector.setCount(cat.label, cat.patients.length);
        });
      } else {

        _.each(column.patients, function (p) {
          columnDataCollector.addValue(p.value);
        });
      }

      updateHandler.publishExternalData(column.id, columnDataCollector);
    });
  }

  // reset the external header by the current number of populated patients
  var header = void 0;
  if (nrPatients) {
    header = { suffix: ' | n=' + nrPatients };
  }
  updateHandler.externalDataTarget.setHeader(header);
};

updateHandler.factorDataCollector = function (column) {

  if (!column.categories) {
    return updateHandler.externalDataTarget.factorColumnDataCollector(column.id, "numeric");
  }

  return updateHandler.externalDataTarget.factorColumnDataCollector(column.id, "category");
};

updateHandler.publishExternalData = function (columnId, columnDataCollector) {

  // invoke the charts data listener on the column's data change
  var eventData = {
    categories: columnDataCollector.getCategories(),
    population: updateHandler.stateProps.data.patients.length
  };

  updateHandler.externalDataTarget.onDataChanged(columnId, eventData);
};

updateHandler.updateLogi = function (filterProps) {

  console.log('filterProps :', filterProps);

  var reportID = updateHandler.stateProps.data.config.logiReportID;
  var params = "";

  _.each(filterProps.data.brushedSelection, function (brushValues, column) {
    var brushedColumn = _.find(updateHandler.stateProps.data.parallelPlot, function (c) {
      return c.column.id === column;
    });
    var digits = brushedColumn.brushProps.digits;
    params += '&' + column + 'Min=' + brushedColumn.column.scaleY.invert(brushValues[1]).toFixed(digits);
    params += '&' + column + 'Max=' + brushedColumn.column.scaleY.invert(brushValues[0]).toFixed(digits);
  });

  _.each(filterProps.data.columnSelection, function (categories, column) {
    var cFilters = [];
    _.each(categories, function (c) {
      cFilters.push(c.category);
    });
    if (cFilters.length > 0) params += '&' + column + '=' + cFilters.join();
  });

  // add selected data source
  params += '&rdDataSource=' + document.getElementById("rdDataSource").value;

  console.log('logi callback params :', params);
  console.log('formVars :', 'rdAjaxCommand=RefreshElement&rdRefreshElementID=charts' + params + '&rdReport=' + reportID);
  console.log('rdAjaxRequest(rdAjaxCommand=RefreshElement&rdRefreshElementID=charts' + params + '&rdReport=' + reportID + ',false,' + '' + ',null,null,null,null,true)');
  //console.log('rdAjaxRequest called with private callback');


  if (typeof rdAjaxRequest === "function") {
    console.log('rdAjaxRequest called with private callback');

    rdAjaxRequest('rdAjaxCommand=RefreshElement&rdRefreshElementID=charts' + params + '&rdReport=' + reportID, 'false', '', null, function () {
      logiUpdateCallback();
    }, null, false);
    //Old version of Marc
    //rdAjaxRequestWithFormVars('rdAjaxCommand=RefreshElement&rdRefreshElementID=charts' + params + '&rdReport=SPTreatment','false','',null,null,null,null,true);
  } else {
    console.error('Logi function rdAjaxRequestWithFormVars() not found');
  }

  //updateHandler.updateReportDOM();
};

updateHandler.updateReportDOM = function (filterProps) {

  var n = updateHandler.stateProps.data.totalNRPatients;
  if (filterProps.filtersActive) n = filterProps.data.nrPatients;
  document.getElementById('card-header-procedure-insights').innerHTML = 'Procedure Insights | n=' + n;
};

updateHandler.onResize = function () {
  updateHandler.stateProps.updateType = 'reSize';
  updateHandler.updateGraph(updateHandler.stateProps);
};

updateHandler.buildExternalCollectibleColumns = function (apiDataParallelPlot) {

  updateHandler.extrnalCollectColumns = [];

  // read from the externalDataTarget the IDs for all columns for which it is required to collect data
  if (updateHandler.externalDataTarget && updateHandler.externalDataTarget.getCollectibleColumns) {

    var cols = updateHandler.externalDataTarget.getCollectibleColumns();

    _.each(cols, function (colId) {

      // if column is already collected through the parallelPlot - no need to add it tp the list
      //  of columns to collect
      var column = _.find(apiDataParallelPlot, function (d) {
        return colId == d.column.id;
      });

      if (column) {
        updateHandler.extrnalCollectColumns.push(column);
      } else {
        console.error("cannot find column for external id: " + colId);
      }
    });
  }
};

module.exports = updateHandler;